import { useMemo } from 'react'
import { Trans } from 'react-i18next'

import { ActionFlag } from '@makyoapp/makyo-common'

import { useAppOverlaysContext } from '@/context/AppOverlaysContext'
import { BuilderOverlay } from '@/shared/overlay'
import { BackButton } from '@/components/BackButton'

import OverlaySetting from './OverlaySetting'

function OverlayPanelEdit({ overlay }: { overlay: BuilderOverlay }) {
  const { overlays, activeOverlays, overlayAction, setOverlayAction, closeOverlay } = useAppOverlaysContext()

  const overlayIdx = useMemo(() => {
    return (overlays ?? []).findIndex((o) => o.id === overlay.id)
  }, [overlays, overlay.id])

  const pageTitle = overlay.title
  const isActive = !!activeOverlays.find((o) => o?.id === overlay?.id)

  return (
    <>
      <div className='flex items-center'>
        <BackButton
          bottomBorder
          onClick={() => {
            setOverlayAction(undefined)
            if (isActive) {
              closeOverlay(overlay.id)
            }
          }}
        />
        {overlayAction?.flag === ActionFlag.Edit && (
          <div className='w-full border-b h-12 flex-c justify-end ltr:pr-4 rtl:pl-4 bdr text-m-sm text-primary-500'>
            <Trans>Editing</Trans> {pageTitle}
          </div>
        )}
      </div>
      <OverlaySetting index={overlayIdx} overlay={overlay} />
    </>
  )
}

export default OverlayPanelEdit
